import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import {
  DVFormGroup,
  DVFormControl,
  DVFormArray,
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { SharedService } from '../../shared/shared.service';
import { DestinationsService } from '../destinations.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-add-destination',
  templateUrl: './add-destination.component.html',
  styleUrls: ['./add-destination.component.css'],
})
export class AddDestinationComponent implements OnInit {
  destinationForm: DVFormGroup;
  countries = [];
  cities = [];
  cityId = null;
  countryId = null;
  constructor(
    private sharedService: SharedService,
    private destinationService: DestinationsService,
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.destinationForm = new DVFormGroup({
      facts: new DVFormControl([], {
        'Facts is required': Validators.required,
      }),
      featured: new DVFormControl(),
      CityPictures: new DVFormControl([], {
        'City Images are required': Validators.required,
        // 'You must upload at least two images': Validators.minLength(2)
      }),
    });
    this.sharedService.getAllCountries().subscribe((result: any) => {
      console.log(result);
      this.countries = result.data.countries;
    });
  }

  ngOnInit() {
    this.destinationService
      .getDestination(this.route.snapshot.params.id)
      .subscribe((result) => {
        this.destinationForm.patchValue(result.data.city);
        this.countryId = result.data.city.countryId;
        this.cityId= result.data.city.id;
        this.sharedService.getAllCities(this.countryId).subscribe((result: any) => {
          console.log(result);
          this.cities = result.data.cities;
        });
      });
  }
  getCities(event) {
    console.log(event);
    this.countryId = event.target.value;
    this.sharedService.getAllCities(this.countryId).subscribe((result: any) => {
      console.log(result);
      this.cities = result.data.cities;
    });
  }
  setCity(event) {
    this.cityId = event.target.value;
  }
  UpdateForm() {
    console.log(this.destinationForm.value);
    if (this.destinationForm.valid) {
      this.destinationService
        .updateDestination(this.cityId, this.destinationForm.value)
        .subscribe(
          (result) => {
            this.notifier.success('Destination Added Successfully');
            this.router.navigateByUrl('destinations/list')
          },
          (err) => {
            this.notifier.error(err.error.userMessage);
          }
        );
    } else {
      this.destinationForm.forceShowErrors();
    }
  }
}
